import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import L from "../../components/Lang";
import { qreq } from "../../shared/qrequest";
import { Pop } from "../../components/PopModal";
import Alert from "../../components/Alert";
import APICom from "./components/APICom";
import { SidebarGlobal } from "../../components/Bridge/Sidebar";
import Globals from "../../shared/Globals";
import Tick from "../../components/Tick";

class WebhookLog extends APICom {

    constructor(props) {
        super(props);
        this.state = {
            query: {}, // for apiclient
            list: null,
            scopeList: [],
            webhookScopes: []
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/api-client/list', 'clients');
        await this.fillListAsync('/api/webhook/scope/list', 'scopeList');
        await this.loadAPIClients(true);
        
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.currentClient !== prevState.currentClient) {
            await this.loadAsync();
        }
    }

    loadAsync = async () => {
        if(this.state.currentClient?.id)
            await this.fillListAsync('/api/webhook/log/list?apiClientID=' + this.state.currentClient.id, 'list');
    }


    retrigger = (item) => {
        Pop.showConfirm(<L>Retrigger Webhook</L>, <L>Are you sure you want to retrigger Webhook <strong>{item.eventID}</strong>?</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/webhook/retrigger?apiClientID=' + this.state.currentClient.id, item);
                if (j.errorCode === 0) {
                    this.success(<L>Retriggered Webhook.</L>);
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    tick = async () => {
        await this.loadAsync();
    }

    render() {
        return (
            <div className="container-fluid">



                <h1><L>Webhook Dispatch Log</L></h1>

                <Tick interval={5000} onTick={this.tick} />

                {this.state.list ? <table className="table table-striped">
                    <thead>
                        <tr>
                            <th><L>Date Dispatch</L></th>
                            <th><L>Lab Order ID</L></th>
                            <th><L>Scope</L></th>
                            <th><L>Event ID</L></th>
                            <th><L>HTTP Code</L></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list?.map((i,idx) => <tr key={idx}>
                            <td>{Globals.toMDYHMAMPMLocalDateString(i.dateDispatch)}</td>
                            <td>{i.labOrderID}</td>
                            <td>{i.scope}</td>
                            <td>{i.eventID}</td>
                            <td>{i.responseHTTPCode}</td>
                            <td>
                                <button type="button" className="btn btn-success" onClick={() => this.retrigger(i)}>
                                    <L>RETRIGGER</L>
                                </button>
                            </td>
                        </tr>)}
                    </tbody>
                </table> : <Alert><L>Please select an API Client.</L></Alert>}



            </div>
        )
    }
}

export default withParamsAndNavigate(WebhookLog);